<template>
  <div>
    <el-form :model="form" ref="form" :label-width="formLabelWidth" :rules="rules">
      <el-form-item label="学号" prop="sno">
        <el-input v-model="form.sno" placeholder="请输入学号" clearable :disabled="isEdit"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" v-if="!isEdit">
        <el-input v-model="form.password" placeholder="请输入密码" clearable></el-input>
      </el-form-item> 
      <el-form-item label="年龄" prop="age" v-show="!isPersonalInfo">
        <el-input v-model="form.age" placeholder="请输入年龄" clearable></el-input>
      </el-form-item>      
      <el-form-item label="性别" prop="sex">
        <el-select v-model="form.sex" placeholder="请选择性别" clearable style="width:100%;">
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input v-model="form.phone" placeholder="请输入手机号码" clearable></el-input>
      </el-form-item>
      <el-form-item label="身份证(护照)" prop="sid" v-show="!isPersonalInfo">
        <el-input v-model="form.sid" placeholder="请输入身份证" clearable></el-input>
      </el-form-item>
      <el-form-item label="籍贯" v-show="!isPersonalInfo">
        <el-input v-model="form.nativePlace" placeholder="请输入籍贯" clearable></el-input>
      </el-form-item>
      <el-form-item label="入学年份">
        <el-input v-model="form.enrollmentYear" placeholder="请输入入学年份" clearable></el-input>
      </el-form-item>
      <el-form-item label="班级" prop="kclassName">
        <el-input v-model="form.kclassName" placeholder="请输入班级" clearable></el-input>
        <!-- <el-select v-model="form.kclassCode" placeholder="请选择班级" clearable style="width: 100%;">
          <el-option :label="item.name" v-for="item in classItems" :value="item.code" :key="item.code"></el-option>
        </el-select> -->
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="resetDialog">取 消</el-button> -->
      <el-button type="primary" @click="submitForm('form')">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { updateStudent, addStudent} from '@/api/student'
import CommonUtil from "@utils/common-util"
export default {
  name: "studentForm",
   props: {
    form: Object,
    isEdit:Boolean,
    isPersonalInfo:Boolean
  },
  data() {
    return {
      rules: {
        sno: [{ required: true, message: '请输入学号', trigger: 'blur' }],      
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请输入性别', trigger: 'blur' }],
        sid: [{ required: true, message: '请输入身份证', trigger: 'blur' }],
        kclassName: [{ required: true, message: '请输入班级', trigger: 'blur' }],
      },   
      // form: Object.assign({}, defaultForm), 
      formLabelWidth: '140px',
      // isEdit: false,
      classItems: [],
    }
  },
  created() {
    // this.classItems = JSON.parse(window.sessionStorage.getItem('CLASS_ITEMS'))
  },
  methods: {
    //提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }
        CommonUtil.submitForm(this.isEdit, this.form, addStudent, updateStudent, this.afterSubmit)
      })
    },
    afterSubmit() {
      this.$emit("afterSubmit");      
      // this.dialogVisible = false
      // this.loadData()
    },
    resetDialog() {
      //重置对话框
      this.$refs['form'].resetFields();      
    },
  }
}
</script>

<style  lang="stylus" scoped>
.student-dialog {
  .el-form-item {
    margin-right: 80px;
  }
}
</style>

